// extracted by mini-css-extract-plugin
module.exports = {"table-head-border-bottom":"styles-module__table-head-border-bottom___ZJtGF","actions-column":"styles-module__actions-column___2GykC"};